import {ReactElement, useEffect, useState} from "react"
import Draggable, {DraggableData, DraggableEvent} from "react-draggable"
import {observer} from "mobx-react-lite"
import {isEmpty} from "lodash-es"
import {t} from "@ui/common/intl"
import {usePrevious} from "@ui/common/utils"
import {useStore} from "@ui/stores"
import {TWidgetPosition, Adapter} from "@ui/stores/service/adapter"
import {SpeedUnit} from "@ui/stores/settings"

export const GaugeData = {
	[SpeedUnit.MPerSec]: {
		ratio: 1
	},
	[SpeedUnit.KmPerHour]: {
		ratio: 3.6
	},
	[SpeedUnit.Knots]: {
		ratio: 1.944
	}
}

const Data = (): ReactElement => {
	const {settings: {units}, movement, adapter} = useStore()
	const [positions, setPositions] = useState<{[k: string]: TWidgetPosition}>({})
  const prevWidgets = usePrevious([...adapter.widgets])

  const gaugeData = GaugeData[units.speed]

  useEffect(() => {
    setPositions(adapter.positions)
  }, []);

  useEffect(() => {
    const newPositions: {[k: string]: TWidgetPosition} = {};

    (prevWidgets && prevWidgets.length > adapter.widgets.length ? prevWidgets: adapter.widgets)
      .forEach((widget) => newPositions[widget] = adapter.positions[widget])

    setPositions(prevPositions => ({...prevPositions, ...newPositions}))
  }, [adapter.widgets.length]);

  const handleDragStart = (widget: string, e: DraggableEvent, data: DraggableData) => {
    const {left, top} = data.node.getBoundingClientRect()
    adapter.positions[widget] = {left, top}
  }

  const handleDragStop = (widget: string, e: DraggableEvent, data: DraggableData) => {
    const {x, y} = data
    const {left, top} = positions[widget] || adapter.positions[widget]
    adapter.positions[widget] = {left: left + x, top: top + y}
  }

  let k = 0
	return (
    <>
      <div className="data">
        <div>
          <div className="small-text">{t("screen.data.speed.title")}</div>
          <div>
            <span className="speed-value primary-header-text">
              {Math.round((movement.current?.coords.speed || 0) * gaugeData.ratio * 10) / 10}
            </span>
            <span className="small-text">
              {`${t(`setting.speed.unit.${units.speed}`)}`}
            </span>
          </div>
        </div>
      </div>
      <div className="adapter-data">
        {adapter.widgets.map((widget, i) => {
          const pos = prevWidgets && (prevWidgets.length !== adapter.widgets.length)
            ? adapter.positions
            : positions
          return (
            <Draggable
              key={`draggable-widget-${widget}-${i}-${adapter.widgets.length}`}
              onStart={(e, data) => handleDragStart(widget, e, data)}
              onStop={(e, data) => handleDragStop(widget, e, data)}
            >
              <div
                className="widget"
                style={isEmpty(pos[widget]) ? {right: (100 * k++ + 12) + "px"} : pos[widget]}
              >
                <div className="small-text">
                  {t(`adapter.${adapter.data[widget].name}.title`)}
                </div>
                <div>
                  {
                    adapter.data[widget]
                      ? (<>
                          <span className="primary-header-text value">{Adapter.parseValue(adapter.data[widget])[0]}</span>
                          <span className="small-text">{Adapter.parseValue(adapter.data[widget])[1]}</span>
                        </>)
                      : <span className="regular-text">{t("adapter.no.data")}</span>
                  }
                </div>
              </div>
            </Draggable>
          )
        })}
      </div>
    </>
  )
}

export default observer(Data)
